export default __webpack_public_path__ + "static/continuous-compliance-mobile2-7e9cd0ffc26fa9b603a7b0f59541b99b.jpg";